import InteractionPoint from "../InteractionPoint";
import React from "react";
import { Html } from "@react-three/drei";

export default function HologramInteractions(src) {
  return (
    <>
      <InteractionPoint
        args={[0.25, 0.25, 0.25]}
        position={[-2.948, 0.688, 3.424]}
        module={"holoA"}
        name="LUCIDIS TORIC"
      ></InteractionPoint>

      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-2.615, 0.686, 4.107]}
        module={"holoB"}
        name="LUCIDIS"
      ></InteractionPoint>

      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-3.699, .688, 3.257]}
        module={"holoC"}
        name="EDEN TORIC"
      >

      </InteractionPoint>


      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-2.959, 0.689, 4.826]}
        module={"holoD"}
        name="EDEN"
      ></InteractionPoint>

      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-2.959, 1.689, 4.826]}
        module={"InstantFocusPdf"}
      ></InteractionPoint>
      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-4.059, 1.689, 4.026]}
        module={"Certificate"}
      ></InteractionPoint>
      <InteractionPoint
        args={[0.15, 0.15, 0.15]}
        position={[-4.059, 1.689, 2.526]}
        module={"Map"}
        src={src}
      ></InteractionPoint>
    </>
  );
}
